/** @file Error - Renders critical validation error messages. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as constants from '../constants';
const textColor = {
    neutral: ['text-neutral-60 dark:text-neutral-20'],
    highlighted: ['text-highlighted-60 dark:text-highlighted-20'],
    critical: ['text-critical-60 dark:text-critical-20'],
    actionable: ['text-actionable-60 dark:text-actionable-20'],
};
const bgColor = {
    neutral: ['bg-neutral-2 dark:bg-neutral-70'],
    highlighted: ['bg-highlighted-2 dark:bg-highlighted-70'],
    critical: ['bg-critical-2 dark:bg-critical-70'],
    actionable: ['bg-actionable-2 dark:bg-actionable-70'],
};
/** Message renders a message in the form, give it a validation, error, or just some other message. */
export const Message = tsx.withHtmlAttrs(tsx.component({
    name: constants.nameMessage,
    props: {
        /** Semantic of the message. */
        semantic: p
            .ofStringLiterals('neutral', 'highlighted', 'critical', 'actionable')
            .default('neutral'),
        /** Variant of the message. */
        variant: p.ofStringLiterals('default', 'box').default('default'),
    },
    /** @returns Nodes. */
    render() {
        return (<section class={[
                constants.nameMessage,
                'body-small',
                textColor[this.semantic],
                {
                    default: '',
                    box: ['p-3! rounded-xs', bgColor[this.semantic]],
                }[this.variant],
            ]}>
                    {this.$slots.default}
                </section>);
    },
}));
